import React from 'react';
import { EntitlementType } from '../@types/entitlement';
import { useGetEntitlements } from '../apiHooks/entitlements.hook';

export const useGetHasEntitlement = (entitlementType: EntitlementType) => {
  const { entitlements } = useGetEntitlements();
  return React.useMemo(() => {
    if (!entitlements || !entitlements?.length) return false;
    return entitlements?.some((entitlement) => entitlement.serviceType === entitlementType);
  }, [entitlementType, entitlements]);
};

export const useTenantProtectionEntitlement = (): boolean => {
  return useGetHasEntitlement(EntitlementType.TENANT_PROTECTION_SERVICE);
};

const PREMIUM_SUBSCRIPTION_ENTITLEMENTS_ARRAY: EntitlementType[] = [
  EntitlementType.PREMIUM_RENT,
  EntitlementType.PREMIUM_BUY,
];

export const usePremiumSubscriptionEntitlement = (): boolean | null => {
  const { entitlements } = useGetEntitlements();
  if (!entitlements || !entitlements?.length) return false;
  return entitlements?.some((e) => PREMIUM_SUBSCRIPTION_ENTITLEMENTS_ARRAY.includes(e.serviceType)) ?? null;
};
